var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1026_4772)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 11C17.84 11 18.17 11.04 18.5 11.09V6.27L11 3L3.5 6.27V11.18C3.5 15.72 6.7 19.97 11 21C11.55 20.87 12.08 20.68 12.6 20.45C11.91 19.47 11.5 18.28 11.5 17C11.5 13.69 14.19 11 17.5 11Z",
    fill: "#223CDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 13C15.29 13 13.5 14.79 13.5 17C13.5 19.21 15.29 21 17.5 21C19.71 21 21.5 19.21 21.5 17C21.5 14.79 19.71 13 17.5 13ZM17.5 14.38C18.12 14.38 18.62 14.89 18.62 15.5C18.62 16.11 18.11 16.62 17.5 16.62C16.89 16.62 16.38 16.11 16.38 15.5C16.38 14.89 16.88 14.38 17.5 14.38ZM17.5 19.75C16.57 19.75 15.76 19.29 15.26 18.58C15.31 17.86 16.77 17.5 17.5 17.5C18.23 17.5 19.69 17.86 19.74 18.58C19.24 19.29 18.43 19.75 17.5 19.75Z",
    fill: "#223CDD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1026_4772"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminActive);
export default __webpack_public_path__ + "static/media/admin_active.1545693f8d6197a06dda709b3b877788.svg";
export { ForwardRef as ReactComponent };